import React from 'react'
type propsSide = {
    isActive: boolean,
    [key: string]: unknown;
}

export const SideA = ({ isActive, ...props }: propsSide) => {
    let colorSide: string = `#EDEAE2`
    if (isActive) colorSide = `#425D76`

    let colorText: string = `#BBB5AA`
    if (isActive) colorText = `#040503`

    return (
        <svg width="76" height="84" viewBox="0 0 76 84" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <path d="M75 50.4083L60.3276 65.8083H1V31.8L15.6724 16.4L44.6983 1L75 16.4V50.4083Z" fill="white" />
            <path d="M1 65.8082V31.8068L30.0259 16.3999L60.3276 31.8068V65.8082H1Z" fill={colorSide} stroke={colorText} />
            <path d="M15.6724 50.4083V16.4069L44.6982 1L74.9999 16.4069V50.4083H15.6724Z" stroke={colorText} />
            <path d="M75 16.3999L60.3276 32.1207V65.8082L75 50.4082V16.3999Z" stroke={colorText} strokeLinejoin="round" />
            <path d="M15.6724 16.3999L1 31.7999V65.8082L15.6724 50.4082V16.3999Z" stroke={colorText} strokeLinejoin="round" />
            <path d="M30.0259 16.4L45.0173 1" stroke={colorText} />
            <path d="M41.9368 80.6667H37.469L36.4656 83.45H35.0154L39.0876 72.7859H40.3181L44.3977 83.45H42.9548L41.9368 80.6667ZM37.8938 79.5095H41.5193L39.7029 74.5217L37.8938 79.5095Z" fill={colorText} />
        </svg>
    )
}
